import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  formatWithBranchLabel,
  getBranchName,
  shouldShowBranchLabels,
} from '../utils/branchLabels';

export default function useBranchLabels() {
  const { user, activeBranchId } = useAuth();

  const showBranchLabels = useMemo(
    () => shouldShowBranchLabels(user, activeBranchId),
    [user, activeBranchId],
  );

  const formatLabel = useMemo(
    () => (name, row) => formatWithBranchLabel(name, getBranchName(row), showBranchLabels),
    [showBranchLabels],
  );

  return { showBranchLabels, formatLabel, getBranchName };
}
